<template>
     <div class="rule-routing">
          <div class="w-content">
            <a-layout>
                <a-layout-sider width="180" class="sideBar-n"><SideBar class="side-bar-layout"></SideBar></a-layout-sider>
                <a-layout-content><router-view></router-view></a-layout-content>
            </a-layout>
            <a-back-top />
         </div>
    </div>
</template>
<script>
import {Layout,BackTop} from 'ant-design-vue'
import SideBar from './components/sideBar/index.vue'
export default {
    components:{SideBar,'a-layout':Layout,'a-layout-sider':Layout.Sider,'a-layout-content':Layout.Content,[BackTop.name]:BackTop}
}
</script>
<style lang="scss">
 .rule-routing {
     .sideBar-n .ant-layout-sider-children {
        display: flex;
    }
 }
</style>

<style lang="scss" scoped>
.rule-routing {
    padding-top: 15px;
    .w-content>.ant-layout {
        padding: 0 15px;
    }
    .ant-layout-sider {
        background-color: transparent;
        display: flex;
    }
    .ant-layout-content {
        margin-left: 15px;
    }
    .side-bar-layout {
        flex: 1 1 auto;
        
    }
    
}
</style>


